import { init as init$3 } from '@cian/config/browser';
import { init as init$1 } from '@cian/logger/browser';
import { ConfigurationError } from '@cian/peperrors/shared';
import { init as init$2 } from '@cian/telemetry/browser';
import { HttpApi } from './internal/HttpApi/HttpApi.mjs';
import { BadStatusCodeHook } from '../shared/internal/Hooks/BadStatusCodeHook.mjs';
import { CancellationTokenHook } from '../shared/internal/Hooks/CancellationTokenHook.mjs';
import { CircuitBreakerHook } from '../shared/internal/Hooks/CircuitBreakerHook.mjs';
import { TelemetryHook } from '../shared/internal/Hooks/TelemetryHook.mjs';

let httpApi;
let httpApiSetupSettings;
const setup = (settings) => {
    httpApiSetupSettings = settings;
};
const init = () => {
    if (httpApi) {
        return httpApi;
    }
    init$1();
    const telemetry = init$2();
    const config = init$3();
    const internalHttpApi = new HttpApi(httpApiSetupSettings);
    internalHttpApi.addHook(params => new TelemetryHook(Object.assign({ telemetry }, params)));
    if (config.get('http.browser.cb-enabled')) {
        internalHttpApi.addHook(params => new CircuitBreakerHook(params));
    }
    internalHttpApi.addHook(params => new CancellationTokenHook({ token: params.context.cancellationToken }));
    internalHttpApi.addHook(params => new BadStatusCodeHook(params));
    httpApi = internalHttpApi;
    return httpApi;
};
const getHttpApi = () => {
    if (!httpApi) {
        throw new ConfigurationError({
            message: 'HttpApi not initialized yet, call init function first',
            domain: 'http-api.getHttpApi',
        });
    }
    return httpApi;
};

export { getHttpApi, init, setup };
//# sourceMappingURL=interface.mjs.map
